export const convertToHoursFormat = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    const hoursStr = String(hours).padStart(2, '0');
    const minutesStr = String(remainingMinutes).padStart(2, '0');

    return `${hoursStr}:${minutesStr}`;
};